import React from "react";
import PropTypes from "prop-types";
import useCallinStatus from "../../../hooks/useCallinStatus/useCallinStatus";
import TextPill from "../../Pills/TextPill/TextPill";

export default function CallinStatusPill({ value }) {
  const { currentStatus } = useCallinStatus(value);

  return (
    <span>
      {currentStatus &&
        <TextPill
          value={currentStatus.name}
          backgroundColor={currentStatus.backgroundColor}
          color={currentStatus.color}
          padding="2px 6px"
        />
      }
    </span>
  );
}

CallinStatusPill.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};